import { ReactNode } from "react"
import { Box, BoxProps, VStack } from "@chakra-ui/react"

export default function StbtcSuccessScreenBody({
  children,
  ...props
}: BoxProps & {
  children: ReactNode
}) {
  return (
    <Box p="40px 48px" bg="stbtc.yellow" color="primary.black.100" {...props}>
      <VStack gap={0}>{children}</VStack>
    </Box>
  )
}
